export const ApiRoutes = {
  getAllCheckInsByActivityId: 'check-in',
  basePath: 'api/v1/',
  getUserRole: 'users/{id}/role',
  getUserById: 'users/{id}',
  getCoachLeaderBoard: 'check-in/leader-board',
  getUserMe: 'users/me',
  searchForUser: 'users',
  loginUser: 'auth/login',
  logoutUser: 'auth/logout',
  deleteUser: 'users',
  refreshToken: 'auth/refresh',
  registerUser: 'users/register',
  updateUser: 'users/update',
  changePassword: 'users/password',
  verifyUser: 'users/verify',
  resetPw: 'users/password/reset',
  setPassword: 'users/password/set',
  weightById: 'weight/{id}',
  weights: 'weight',
  activitiesById: 'activities/{id}',
  activities: 'activities',
  checkInManuallyById: 'check-in/manual',
  checkInById: 'check-in/{id}',
  checkInRanking: 'check-in/ranking',
  checkInDataExport: 'check-in/export',
};
